/* Lemyn AI shopper (Joe). Loaded from snippets/lemyn-after.liquid on every shop page. Nothing a person sees.
   29 Oct 2026, "no shop visit = agent": Grok Bot no longer browses our pages, it builds the checkout on xAI's servers
   through Shopify's agent checkout and lands straight on /checkouts. So we mark the HUMAN path instead:
   every cart that went through our pages carries cart attribute lemyn_web = "1" (also on our /cart/V:Q links).
   The "Lemyn Bundle & Pro" function gives the flat 25% to any cart WITHOUT that mark, or with lemyn_ai = "1"
   (a browsing robot we can still see: webdriver/bot user agent, or a Linux desktop). Never stacked with the bundle;
   business accounts excluded. Joe accepts the odd human who skips our pages getting 25% ("the rest we take"). */
(function () {
  try {
    var ua = navigator.userAgent || '';
    if (/googlebot|bingbot|adsbot|applebot|duckduckbot|yandex|baidu|facebookexternalhit|twitterbot|lighthouse|pingdom|semrush|ahrefs/i.test(ua)) return;
    var auto = navigator.webdriver === true || /bot|crawl|spider|slurp|headless/i.test(ua);
    // Grok Bot as it browsed on 24 Oct: a normal Chrome on a Linux desktop (X11; Linux x86_64), no robot flag.
    if (!auto && /X11; Linux x86_64/.test(ua) && !/Android|CrOS/.test(ua)) auto = true;

    var ATTR = { lemyn_web: '1' };
    if (auto) ATTR.lemyn_ai = '1';

    var last = 0;
    function mark(force) {
      var now = Date.now();
      if (!force && now - last < 1500) return;
      last = now;
      fetch('/cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ attributes: ATTR })
      }).catch(function () {});
    }
    mark(true);

    // Our checkout buttons are cart links (/cart/VARIANT:QTY,...). They build a fresh checkout, so they carry the mark.
    function tagged(href) {
      try {
        var u = new URL(href, location.href);
        if (!/(^|\.)(lemynorganics\.com|lemyn\.com|lemyn\.myshopify\.com)$/.test(u.hostname) && u.origin !== location.origin) return null;
        if (!/^\/cart\/\d+:\d+/.test(u.pathname)) return null;
        var changed = false;
        for (var k in ATTR) if (u.searchParams.get('attributes[' + k + ']') !== ATTR[k]) { u.searchParams.set('attributes[' + k + ']', ATTR[k]); changed = true; }
        return changed ? u.toString() : null;
      } catch (e) { return null; }
    }
    function tagLink(a) {
      var h = a && a.getAttribute && a.getAttribute('href');
      if (!h || h.indexOf('/cart/') < 0) return false;
      var t = tagged(h);
      if (t) a.setAttribute('href', t);
      return true;
    }
    function sweep() { var l = document.querySelectorAll('a[href*="/cart/"]'); for (var i = 0; i < l.length; i++) tagLink(l[i]); }
    function onPoint(ev) {
      var a = ev.target && ev.target.closest ? ev.target.closest('a[href]') : null;
      if (!(a && tagLink(a))) mark();
    }
    ['mousedown', 'touchstart', 'click', 'auxclick', 'contextmenu'].forEach(function (t) { document.addEventListener(t, onPoint, true); });
    document.addEventListener('keydown', function (ev) { if (ev.key === 'Enter') onPoint(ev); }, true);
    if (window.MutationObserver) new MutationObserver(sweep).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['href'] });
    sweep(); setInterval(sweep, 1500);

    // Forms that post to the cart (Subscribe & Save, Shopify's own cart page): add the mark as hidden fields,
    // including forms sent by script with form.submit(), which fires no submit event.
    function tagForm(f) {
      try {
        var act = new URL(f.getAttribute('action') || location.href, location.href);
        if (!/^\/cart(\/add)?(\.js)?$/.test(act.pathname)) return;
        for (var k in ATTR) {
          var n = 'attributes[' + k + ']';
          if (f.querySelector('input[name="' + n + '"]')) continue;
          var i = document.createElement('input'); i.type = 'hidden'; i.name = n; i.value = ATTR[k]; f.appendChild(i);
        }
      } catch (e) {}
    }
    document.addEventListener('submit', function (ev) { if (ev.target && ev.target.tagName === 'FORM') tagForm(ev.target); mark(); }, true);
    var sub = HTMLFormElement.prototype.submit;
    HTMLFormElement.prototype.submit = function () { tagForm(this); return sub.apply(this, arguments); };

    // Anything that clears or rebuilds the cart by script gets the mark again right after.
    if (window.fetch) {
      var f0 = window.fetch;
      window.fetch = function (input, init) {
        var p = f0.apply(this, arguments);
        try {
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          if (/\/cart\/(clear|add|change)(\.js)?(\?|$)/.test(url)) p.then(function () { mark(true); }, function () {});
        } catch (e) {}
        return p;
      };
    }
  } catch (e) {}
})();
